module.exports = __webpack_public_path__ + "static/img/SketchPng0b1a604e628f2e9ed91d75bd55d4436aab8ef7764bae2ea236e89241a73db853.938c681c.png";